module.exports = __webpack_public_path__ + "static/media/CalcMahjong.5d4b7617.jpg";